import axios from "@/utils/request";
import { NEWS_TYPE, NEWS_TYPE_ID_MAP } from "@/constants/const";

const DEFAULT_STORE_KEY = NEWS_TYPE_ID_MAP[NEWS_TYPE.LATEST].key;

const getStoreKeyByType = (typeId) =>
  NEWS_TYPE_ID_MAP[typeId]?.key || DEFAULT_STORE_KEY;

const LATEST_STORE_KEY = NEWS_TYPE_ID_MAP[NEWS_TYPE.LATEST].key;
const MEDIA_STORE_KEY = NEWS_TYPE_ID_MAP[NEWS_TYPE.MEDIA].key;
const ACTIVITY_STORE_KEY = NEWS_TYPE_ID_MAP[NEWS_TYPE.ACTIVITY].key;
const TREND_STORE_KEY = NEWS_TYPE_ID_MAP[NEWS_TYPE.TREND].key;

const state = {
  // 列表页数据
  [LATEST_STORE_KEY]: { list: [], total: 0 },
  [MEDIA_STORE_KEY]: { list: [], total: 0 },
  [ACTIVITY_STORE_KEY]: { list: [], total: 0 },
  [TREND_STORE_KEY]: { list: [], total: 0 },
  // 详情页数据
  currentInfo: null,
};

const mutations = {
  // 设置最新动态列表
  SET_LATEST_LIST(state, { list, total }) {
    state[LATEST_STORE_KEY].list = list;
    state[LATEST_STORE_KEY].total = total;
  },
  // 追加最新动态列表
  APPEND_LATEST_LIST(state, { list, total }) {
    state[LATEST_STORE_KEY].list = [...state[LATEST_STORE_KEY].list, ...list];
    state[LATEST_STORE_KEY].total = total;
  },
  // 设置媒体报道列表
  SET_MEDIA_LIST(state, { list, total }) {
    state[MEDIA_STORE_KEY].list = list;
    state[MEDIA_STORE_KEY].total = total;
  },
  // 追加媒体报道列表
  APPEND_MEDIA_LIST(state, { list, total }) {
    state[MEDIA_STORE_KEY].list = [...state[MEDIA_STORE_KEY].list, ...list];
    state[MEDIA_STORE_KEY].total = total;
  },
  // 设置活动资讯列表
  SET_ACTIVITY_LIST(state, { list, total }) {
    state[ACTIVITY_STORE_KEY].list = list;
    state[ACTIVITY_STORE_KEY].total = total;
  },
  // 追加活动资讯列表
  APPEND_ACTIVITY_LIST(state, { list, total }) {
    state[ACTIVITY_STORE_KEY].list = [...state[ACTIVITY_STORE_KEY].list, ...list];
    state[ACTIVITY_STORE_KEY].total = total;
  },
  // 设置流行趋势列表
  SET_TREND_LIST(state, { list, total }) {
    state[TREND_STORE_KEY].list = list;
    state[TREND_STORE_KEY].total = total;
  },
  // 追加流行趋势列表
  APPEND_TREND_LIST(state, { list, total }) {
    state[TREND_STORE_KEY].list = [...state[TREND_STORE_KEY].list, ...list];
    state[TREND_STORE_KEY].total = total;
  },
  // 设置当前详情信息
  SET_CURRENT_INFO(state, info) {
    state.currentInfo = info;
  },
  // 清空当前详情信息
  CLEAR_CURRENT_INFO(state) {
    state.currentInfo = null;
  },
};

const actions = {
  // 获取列表数据
  async fetchList(
    { commit },
    { type, page = 1, pageSize = 12, append = false }
  ) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      try {
        const res = await axios.get("/api/articles/", {
          params: {
            type,
            page,
            limit:pageSize,
          },
        });
        const list = (res && res.list) || [];
        const total = (res && res.count) || 0;

        const storeKey = getStoreKeyByType(type);
        const mutationMap = {
          [LATEST_STORE_KEY]: append ? "APPEND_LATEST_LIST" : "SET_LATEST_LIST",
          [MEDIA_STORE_KEY]: append ? "APPEND_MEDIA_LIST" : "SET_MEDIA_LIST",
          [ACTIVITY_STORE_KEY]: append ? "APPEND_ACTIVITY_LIST" : "SET_ACTIVITY_LIST",
          [TREND_STORE_KEY]: append ? "APPEND_TREND_LIST" : "SET_TREND_LIST",
        };

        const mutation = mutationMap[storeKey];
        console.log(mutation, list, total);
        if (mutation) {
          commit(mutation, { list, total });
        }
        resolve({ list, total });
      } catch (error) {
        console.error(error);
        resolve({ list: [], total: 0 });
      }
    });
  },

  // 获取详情数据
  async fetchDetail({ commit }, id) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      try {
        const res = await axios.get(`/api/articles/${id}`);
        const info = res || {};
        commit("SET_CURRENT_INFO", info);
        resolve(info);
      } catch (error) {
        console.error(error);
        resolve({});
      }
    });
  },

  // 清空详情数据
  clearDetail({ commit }) {
    commit("CLEAR_CURRENT_INFO");
  },
};

const getters = {
  // 根据类型获取列表
  getListByType: (state) => (type) => {
    const listMap = {
      latest: state.latest,
      media: state.media,
      activity: state.activity,
      trend: state.trend,
    };
    return listMap[type] || { list: [], total: 0 };
  },

  // 获取当前详情
  getCurrentInfo: (state) => state.currentInfo,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
